// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Children_cls1__R6P9H","cls2":"VeloLogoPage-Children_cls2__gvN0j VeloLogoPage-Children_cls1__R6P9H"};